import styled from 'styled-components';

export const FilterBar = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0 var(--spacing-md);
  align-items: end;

  @media (max-width: 760px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 460px) {
    grid-template-columns: 1fr;
  }
`;

export const PresetRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;

  button {
    padding: 7px 14px;
    border-radius: var(--radius-round);
    border: 1.5px solid var(--border-medium);
    background: var(--white);
    color: var(--text-secondary);
    font-family: var(--font-brand);
    font-size: var(--text-sm);
    font-weight: 600;
    cursor: pointer;
  }

  button:hover { border-color: var(--secondary); color: var(--secondary); }
  button[aria-pressed='true'] {
    background: var(--primary);
    border-color: var(--primary);
    color: var(--text-on-primary);
  }
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;

  .stat {
    background: var(--primary-subtle);
    border-radius: var(--radius-md);
    padding: 14px 16px;
    min-width: 0;
  }

  .stat .value {
    font-size: var(--text-2xl);
    font-weight: 800;
    letter-spacing: -0.5px;
    color: var(--primary);
    overflow-wrap: anywhere;
  }

  .stat .label {
    font-size: var(--text-xs);
    font-weight: 600;
    color: var(--text-secondary);
  }

  .caption {
    grid-column: 1 / -1;
    font-size: var(--text-xs);
    color: var(--text-muted);
    line-height: 1.45;
  }

  @media (max-width: 460px) {
    gap: 8px;
    .stat { padding: 12px 10px; }
    .stat .value { font-size: var(--text-xl); }
    grid-template-columns: repeat(2, minmax(0, 1fr));
    .stat:nth-of-type(3) { grid-column: 1 / -1; }
  }
`;

export const SaleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SaleRow = styled.button`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 4px 14px;
  align-items: center;
  width: 100%;
  text-align: left;
  background: var(--bg-card);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  padding: 14px 16px;
  font-family: var(--font-brand);
  color: var(--text-primary);
  cursor: pointer;
  box-shadow: var(--shadow-xs);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
  min-width: 0;

  &:hover { border-color: var(--secondary); box-shadow: var(--shadow-sm); }

  .ticket {
    font-size: var(--text-xl);
    font-weight: 800;
    color: var(--primary);
    min-width: 48px;
  }

  .main { min-width: 0; }
  .title { font-weight: 700; overflow-wrap: anywhere; }
  .meta { font-size: var(--text-sm); color: var(--text-secondary); overflow-wrap: anywhere; }
  .side { text-align: right; display: flex; flex-direction: column; align-items: flex-end; gap: 4px; }
  .amount { font-weight: 800; color: var(--secondary); }

  &[data-voided='true'] { background: var(--bg-section); }
  &[data-voided='true'] .amount { text-decoration: line-through; }

  @media (max-width: 460px) {
    grid-template-columns: minmax(0, 1fr) auto;
    .ticket { grid-column: 1 / -1; font-size: var(--text-lg); }
  }
`;

export const Pager = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-top: 16px;

  span { font-size: var(--text-sm); color: var(--text-secondary); }
`;

export const HeadRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px 16px;
  margin-bottom: 16px;

  > div:first-child { min-width: 0; flex: 1 1 260px; }

  h1 {
    font-size: var(--text-3xl);
    letter-spacing: -0.5px;
    margin-bottom: 4px;
  }

  p { color: var(--text-secondary); }

  @media (max-width: 560px) {
    h1 { font-size: var(--text-2xl); }
  }
`;

export const EmptyBox = styled.div`
  text-align: center;
  padding: 40px 16px;
  border: 1px dashed var(--border-medium);
  border-radius: var(--radius-lg);
  background: var(--bg-card);
  color: var(--text-secondary);
  font-size: var(--text-sm);

  h3 { color: var(--text-primary); margin-bottom: 6px; }
`;

export const WarningPanel = styled.div`
  border: 1.5px solid ${props => (props.$active ? 'var(--danger)' : 'var(--warning-border)')};
  background: ${props => (props.$active ? 'var(--danger-subtle)' : 'var(--warning-subtle)')};
  color: ${props => (props.$active ? 'var(--danger-dark)' : 'var(--warning-dark)')};
  border-radius: var(--radius-md);
  padding: 12px 14px;
  font-size: var(--text-sm);
  line-height: 1.5;
  margin-top: 10px;

  strong { color: inherit; }
`;
